import PropTypes from "prop-types"


const ExportColumnShape = PropTypes.exact({
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.func ]).isRequired,
})

export default ExportColumnShape
